
export default class TriageCriteriumAntwoord {
    id: number;
    omschrijving: string;
    sortering: number;
}
